// eslint-disable-next-line import/no-named-as-default
import produce from 'immer';
import { batchActions } from './utils';
import { setData } from './data';
import { setStatus, unsetStatus } from './status';
import { LOADING, ERROR, UNAUTHORIZED, selectPodcastMetadataStatus } from './selectors';
import { toJSON, PODCASTERS_SERVICE } from '../lib/Request/';
import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';
import { Thunk } from '../types';

const KEY = 'podcastMetadata';

export const loadPodcastMetadata = (podcastId: string): Thunk => async (
  dispatch,
  getState,
  { request },
) => {
  const endpoint = `${PODCASTERS_SERVICE}/v0/shows/${podcastId}/metadata?noCache=true`;

  /* istanbul ignore next */
  if (selectPodcastMetadataStatus(getState()) === LOADING) return;

  dispatch(setStatus({ [KEY]: LOADING }, 'audience/LOAD_PODCAST_METADATA_REQUEST'));

  try {
    const data = await request.get(endpoint).then(toJSON);

    dispatch(
      batchActions(
        [setData({ [KEY]: data }), unsetStatus([KEY])],
        'audience/LOAD_PODCAST_METADATA_SUCCESS',
      ),
    );
  } catch (err) {
    switch (err.name) {
      case 'ResponseError':
      case 'TokenError': {
        if (err.message === '403') {
          dispatch(setStatus({ [KEY]: UNAUTHORIZED }, 'audience/LOAD_UNAUTHORIZED'));
        } else {
          dispatch(setStatus({ [KEY]: ERROR }, 'audience/LOAD_PODCAST_METADATA_ERROR'));
        }
        break;
      }

      /* istanbul ignore next */
      default:
        throw err;
    }
  }
};

export const optimisticUpdatePodcastMetadata = (changes: {
  feedUrl: string;
  network: {
    id: string;
    name: string;
  };
}): ThunkAction<void, any, null, Action> => {
  return (
    dispatch,
    getState,
  ): {
    undoChanges(): void;
  } => {
    const currentState = getState();
    const previousMetadata = currentState.data[KEY];

    const nextState = produce(previousMetadata, draft => {
      draft.feedUrl = changes.feedUrl;
      draft.network = changes.network;
    });

    dispatch(setData({ [KEY]: nextState }));

    return {
      undoChanges() {
        dispatch(setData({ [KEY]: previousMetadata }));
      },
    };
  };
};
